import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Favorite} from '@models/favorite';
import {TrackingService} from '@services/tracking.service';
import * as $ from 'jquery';
import {Router} from '@angular/router';

@Component({
  selector: 'app-preview-popup',
  templateUrl: './preview-popup.component.html',
  styleUrls: ['./preview-popup.component.scss']
})
export class PreviewPopupComponent implements OnInit {

    favorite: Favorite
    url = '';

    constructor(
        public trackingService: TrackingService,
        public dialogRef: MatDialogRef<PreviewPopupComponent>,
        public router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.favorite = this.data.favorite;
        this.favorite.ad.description = this.favorite.ad.description.replace(/\\r\\n\\r/gm, '<br/>').replace(/\\n/gm, '<br/>').replace(/\\r/gm, '');
        this.url = this.data.url;
    }

    changeImg(event, i, id) {
        if (i === 0) {
            event.target.src = 'assets/vendu.png';
            $('.card-' + id).addClass('sell');
        }
    }

    onNoClick() {
        this.dialogRef.close(false);
    }
    onYesClick() {
        this.dialogRef.close(true);
    }
}
